import { useEffect, useState } from "react";
import { User } from "../globalTypes";
import { requestGetUser } from "../requests/users/requestCreators";

const useUserById = (id: number | null) => {
  const [user, setUser] = useState<User | null>(null);

  const getAndSetUser = () => {
    if (id === null) return;
    requestGetUser(id).then((res) => setUser(res.data));
  };

  useEffect(getAndSetUser, [id]);

  return user;
};

export default useUserById;
